<template>
    <div class="webcam-container" :style="{width:width+'px',height:height+'px'}">
      <transition-group name="fade">
        <div key="stream" class="webcam-window" ref="streamingContainer" :class="{blur}"></div>
        <div key="overlay" class="webcam-window">
          <RecordDot v-if="active"></RecordDot>
          <div v-if="loading && countdown!==null" class="overlay-center">{{$t('components.video_record.get_ready')}}</div>
          <div v-else-if="currentCountdown!==null && countdown!==null" class="overlay-center" style="font-size:70pt">{{currentCountdown}}</div>
          <Reconnecting v-if="reconnecting" :small="small"></Reconnecting>
<!--          <RecordingError v-if="error" :error="error" @dismiss="error=null" :small="small"></RecordingError>-->
          <RecordingNetworkQuality :quality="networkQualityLevel" v-if="networkQualityLevel && showNetworkQuality" style="position: absolute; bottom:10px; right:10px;" ></RecordingNetworkQuality>
        </div>
      </transition-group>
    </div>
</template>

<script>
  import {configureDevices} from "../../lib/mediaDevices";
  import {createLocalAudioTrack,createLocalVideoTrack,connect} from 'twilio-video'
  import RecordDot from "../helpers/RecordDot";
  import Reconnecting from "./components/Reconnecting";
  //import RecordingError from "./components/RecordingError";
  import RecordingNetworkQuality from "./components/RecordingNetworkQuality";
  import RecordRTC from 'recordrtc';
  import soundController from "../../lib/soundController";
  import audioInputMixin from "../settings/audioInputMixin";
  export default {
    name: "TwilioWebcam",
    mixins:[audioInputMixin],
    components:{
      RecordDot, Reconnecting,RecordingNetworkQuality//,RecordingError
    },
    props: {
      recordingWidth:{
        default:640
      },
      width:{
        default:640
      },
      height:{
        default:480
      },
      disconnectOnReconnecting:{
        type:Boolean,
        default:true
      },
      countdown:{
        default:null
      },
      recordLocal:{
        type:Boolean,
        default:true
      },
      autoRecord:{
        type:Boolean,
        default:false
      },
      playSounds:{
        type:Boolean,
        default:false
      },
      showNetworkQuality:{
        type:Boolean,
        default:true
      },
      transcribe:{
        type:Boolean,
        default:true
      },
      analyzeSecurity:{
        type:Boolean,
        default:false
      },
      testMode:{
        default:false
      },
      blur:{
        default:false
      }
    },
    data(){
      return {
        room : null,
        loading : false,
        isStreaming:false,
        active: false,
        tracks : [],
        responsevideo:null,
        currentCountdown:null,
        reconnecting:null,
        error:null,
        networkQualityLevel:null,
        countdownInterval:null,
        localRecording:null
      }
    },
    computed:{
      small(){
        return this.width < 640;
      },
      cameraDevice(){
        return this.$store.state.media.cameraDevice;
      },
      audioInputDevice(){
        return this.$store.state.media.audioInputDevice;
      },
      audioOutputDevice(){
        return this.$store.state.media.audioOutputDevice;
      },
      settings(){
        let audio = true;
        let video = { width: this.recordingWidth };
        if(this.cameraDevice){
          video['deviceId']=this.cameraDevice;
        }
        if(this.audioInputDevice){
          audio = {
            deviceId:this.audioInputDevice
          }
        }
        return {
          audio,video
        };
      },
      assessment(){
        return this.$store.state.assessment.assessment;
      },
      connectUrl(){
        if(this.testMode){
          return 'video/test';
        }
        return 'assessments/'+this.assessment.assessmentid+'/responsevideos';
      }
    },
    watch : {
      cameraDevice(){
        this.onDeviceUpdated();
      },
      audioInputDevice(){
        this.onDeviceUpdated();
      }
    },
    created(){

    },
    mounted(){
      this.startLocalOnly().then(()=>{
        if(this.autoRecord){
          setTimeout(()=>{
            if(this){
              this.start();
            }
          },5000);

        }
      });
    },
    methods:{
      startLocalOnly(){
        return this.checkDevicesInStore().then(async ()=>{
          this.tracks=await this.startLocalVideo();
          return this.tracks;
        }).catch((deviceErr)=>{
          this.deviceError(deviceErr);
        });
      },
      async start(){
         this.error=null;
         this.reconnecting=false;
         if(!this.tracks){
           this.tracks=await this.startLocalVideo();
         }
         if(this.playSounds){
           soundController.alert();
         }

         this.connectToRoom().then(()=>{
           this.startCountdown();
         });
      },
      async stop(){
        this.stopCountdown();
        //Fallback for if room disconnect is not triggering
        setTimeout(async ()=>{
            if(this.isStreaming){
                this.isStreaming=false;
                await this.getLocalVideoAndTriggerInactive();
                this.reconnecting=false;
                this.networkQualityLevel=null;
            }
        },2000);
        this.disconnectRoom();
      },
      async startLocalVideo(){
        const videoTrack = await createLocalVideoTrack(this.settings.video);
        const audioTrack = await createLocalAudioTrack(this.settings.audio);
        this.$refs.streamingContainer.innerHTML='';
        const video=videoTrack.attach();
        video.width=this.width;
        video.height=this.height;
        this.$refs.streamingContainer.appendChild(video);
        this.$emit('video-track',video);

        return [videoTrack,audioTrack];
      },
      async stopLocalVideo(){
        this.tracks.forEach((track)=>{
          track.stop();
          track.detach();
        });
      },

      async connectToRoom(){
        if(this.room) return;
        this.setLoading(true);
        this.networkQualityLevel=null;
        try{
          const response=await this.$http.post(this.connectUrl,{
            transcribe:this.transcribe,
            security:this.analyzeSecurity,
          });
          this.responsevideo=response.data.data;
          this.room = await connect(this.responsevideo.room_access_token, {
            name: this.responsevideo.room_name,
            tracks : this.tracks,
            automaticSubscription: false, //Do not subscribe to others in the room
            networkQuality: {
              local:1
            }
          });
          this.room.localParticipant.on('trackPublished', this.onTrackPublished);
          this.room.localParticipant.on('networkQualityLevelChanged', this.onNetworkQualityChanged);
          this.room.on('disconnected',this.onRoomDisconnect);
          this.room.on('reconnecting', this.onRoomReconnecting);
          this.room.on('reconnected', this.onRoomReconnected);
          this.setLoading(false);
          this.isStreaming=true;
          this.$emit('responsevideo',JSON.parse(JSON.stringify(this.responsevideo)));
          return this.room;
        }catch (e) {
           this.setLoading(false);
           this.isStreaming=false;
           this.connectionError();
        }
      },
      setLoading(loading){
        this.loading=loading;
        this.$emit('loading',this.loading);
      },
      connectionError(err){
        this.error = {
          title:'components.video_record.connection_error_title',
          description:'components.video_record.connection_error_desc'
        };
        this.$emit('error',err);
      },
      deviceError(deviceError){
        if(deviceError.toString().includes('Permission denied')){
          deviceError='permission';
        }else if(deviceError.toString().includes('NotReadable')){
          deviceError='busy';
        }
        this.error = {
          title:'components.video_record.device_'+deviceError+'_error_title',
          description:'components.video_record.device_'+deviceError+'_error_desc'
        };
        this.$emit('error',this.error);
      },
      disconnectRoom(){
        if(!this.room) return;
         this.room.disconnect();
         this.room=null;
      },
      onTrackPublished(){
        //console.log(publication);
      },
      onNetworkQualityChanged(networkQualityLevel){
        this.networkQualityLevel=networkQualityLevel;
      },
      async onRoomDisconnect(){
        this.isStreaming=false;
        if(this.reconnecting){
          this.recordingDropped();
        }
        this.reconnecting=false;
        this.networkQualityLevel=null;
        await this.getLocalVideoAndTriggerInactive();
        this.$emit('disconnected');
      },
      async getLocalVideoAndTriggerInactive() {
          let localUrl=null;
          if(this.recordLocal){
              localUrl=await this.stopLocalRecording();
          }

          this.onInactive(localUrl);
      },
      onRoomReconnecting(){
        this.reconnecting=true;
        if(this.disconnectOnReconnecting){
          this.disconnectRoom();
        }
      },
      onRoomReconnected(){
        this.reconnecting=false;
      },
      recordingDropped(){
        this.error={
          title:'components.video_record.recording_dropped_title',
          description:'components.video_record.recording_dropped_desc',
        };
        if(this.playSounds) soundController.criticalError();

        this.$emit('error',this.error);
      },
      publishTracks(tracks){
        if(!this.room) return;
        tracks.forEach((t)=>this.room.localParticipant.publishTrack(t));
      },
      unpublishRoomTracks(){
        if(!this.room) return;
        this.room.localParticipant.tracks.forEach(publication => {
          publication.unpublish();
        });
      },
      detachTracks(tracks){
        tracks.forEach((track)=>{
          const attachedElements = track.detach();
          attachedElements.forEach(element => element.remove());
        });
      },
      onDeviceUpdated(){
        this.checkDevicesInStore().then(async ()=>{
          this.startLocalVideo().then((tracks)=>{
            this.unpublishRoomTracks();
            this.detachTracks(this.tracks);
            this.tracks=tracks;
            this.publishTracks(this.tracks);
          });
        }).catch((deviceErr)=>{
          this.deviceError(deviceErr);
        });
      },
      onActive(){
        if(!this.active){
          //this.startAudioMonitoring();
          if(this.recordLocal){
            this.startLocalRecording();
          }
          this.active=true;
          this.$emit('active');
        }
      },
      onInactive(localVideoUrl=null){
        if(this.active){
         // this.stopAudioMonitoring();
          this.active=false;
          this.$emit('inactive',localVideoUrl);
        }
      },
      startAudioMonitoring(){
        this.initAudioContext();
        this.startAudioInputStream();
        const length=11;
        const buffer=[];
        let errorCount=0;
        let wAvg=0;
        let audioError=false;
        this._audioMonitoringInterval=setInterval(()=>{
          if(buffer.length>length){
            buffer.shift();
          }
          buffer.push(this.audioStreamValue);
          wAvg=buffer.reduce((a, b) => a + b) / buffer.length;
          if(buffer.length>=length && wAvg < 0.05){
            if(!audioError && !this.error){
              this.error={
                title:'components.video_record.no_sound_title',
                description:'components.video_record.no_sound_desc',
              };
              audioError=true;
            }
            errorCount++;
          }else if(buffer.length>=length && audioError){
            audioError=false;
            this.error=null;
            errorCount=0;
          }

          if(errorCount > 15 * 3){ //About 15 seconds
            this.stopAudioMonitoring();
            this.unpublishRoomTracks();
            this.disconnectRoom();
            if(this.playSounds) soundController.criticalError();
            this.$emit('error',this.error);
          }

        },300);
      },
      stopAudioMonitoring(){
        clearInterval(this._audioMonitoringInterval);
        this.stopAudioInputStream();
      },
      startCountdown(){
        if(!this.isStreaming) return;
        if(this.countdown===null){
          this.onActive();
        }
        this.$emit('countdown-started',true);
        this.currentCountdown=this.countdown;

        if(this.playSounds) soundController.clink();

        this.countdownInterval = setInterval(()=>{
          if(!this){
            clearInterval(this.countdownInterval);
            return;
          }

          if(this.currentCountdown===this.$t('general.start')){
            this.stopCountdown();
            this.onActive();
          }else if(this.currentCountdown===1){
            if(this.playSounds) soundController.beep2();
            this.currentCountdown=this.$t('general.start');
          }else{
            if(this.playSounds) soundController.clink();
            this.currentCountdown--;
          }
        },1000);
      },
      stopCountdown(){
        clearInterval(this.countdownInterval);
        this.currentCountdown=null;
        this.$emit('countdown-ended',false);
      },
      checkDevicesInStore(){
        this.listenForDeviceChanges();
        return configureDevices();
      },
      listenForDeviceChanges(){
        navigator.mediaDevices.ondevicechange = ()=>{
          this.handleDeviceChanges();
        }
      },
      async handleDeviceChanges(){
        const mediaDevices=await navigator.mediaDevices.enumerateDevices();
        let cameraDevice=mediaDevices.find(mediaDevice=>mediaDevice.deviceId===this.cameraDevice);
        let audioDevice=mediaDevices.find(mediaDevice=>mediaDevice.deviceId===this.audioInputDevice);
        if(cameraDevice && audioDevice && this.error && (this.error.title.includes('_disconnected_')||this.error.title.includes('device_'))){
          this.onDeviceUpdated();
          this.error=null;
        }

        if(!cameraDevice){
          this.error={
            title:'components.video_record.webcam_disconnected_title',
            description:'components.video_record.webcam_disconnected_desc',
          };
          this.disconnectRoom();
          this.$emit('error',this.error);
          return;
        }

        if(!audioDevice){
          this.error={
            title:'components.video_record.audio_disconnected_title',
            description:'components.video_record.audio_disconnected_desc',
          };
          this.disconnectRoom();
          this.$emit('error',this.error);
        }

        this.error=null;
      },
      startLocalRecording(){
        const stream = new MediaStream();
        for(let track of this.tracks){
          stream.addTrack(track.mediaStreamTrack);
        }
        const options = {
              // eslint-disable-next-line no-useless-escape
            mimeType: 'video/webm\;codecs=vp8', // or video/webm\;codecs=h264 or video/webm\;codecs=vp9
            audioBitsPerSecond: 128000 / 2,
            videoBitsPerSecond: 128000 / 2,
            timeSlice: 2000,
            numberOfAudioChannels: 1
          };
        this.localRecording = RecordRTC(stream, options);
        return new Promise(resolve => {
            this.localRecording.startRecording();
            resolve();
        });
      },
      stopLocalRecording(){
        return new Promise((resolve => {
          this.localRecording.stopRecording(()=>{
              let url = this.localRecording.toURL();
              resolve(url);
             // try{
             //     RecordRTC.getSeekableBlob(this.localRecording.getBlob(), function(seekableBlob) {
             //         let url= URL.createObjectURL(seekableBlob);
             //         resolve(url);
             //     });
             // }catch (e) {
             //     let url = this.localRecording.toURL();
             //     resolve(url);
             // }
          });
        }));
      }
    },
    beforeDestroy() {
      this.stopAudioMonitoring();
      this.unpublishRoomTracks();
      this.stopLocalVideo();
      this.disconnectRoom();
      this.stopCountdown();
    }
  }
</script>

<style scoped>


  .webcam-container{
    position:relative;
    background-color: black;
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    overflow: hidden;
  }

  .webcam-container .webcam-window{
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    border-radius: 10px;

  }

  .webcam-container .webcam-window.blur{
    -o-filter: blur(25px);
    filter: blur(25px);
  }

  .webcam-container .overlay-center{
    font-family: Roboto, sans-serif;
    font-size: 30pt;
    color: white;
    background-color: black;
    opacity: 0.3;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    height:100%;
  }

</style>